module.exports = __webpack_public_path__ + "img/edc-panin.2124ae6f.png";